import WithRender from "../../templates/containers/otherOptionsContainer.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getOtherOptions"]),
    optionsType: () => {
      return "other";
    }
  },
  props: ["hideContainer"]
});
